import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import List from "./audience list components/List";
import SubNavbar from "../../components/SubNavbar";
import { useAxios, useComponent } from "../../hooks";
import { CreateButton } from "../css components/Button";
import { Pagination } from "../../components";
import { getAllAudiences } from "./create audience components/audienceObjects";

export default function AudienceList() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { loader } = useComponent();

  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [audiences, setAudiences] = useState([]);
  const [page, setPage] = useState({ page: 1, totalCount: 0, lastCount: 0 });

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);

    axios({
      url:
        "/brand/getAllAudiences?brandId=" +
        activeBrand.ID +
        `&page=${page.page}&limit=10` +
        (searchKey ? `&search=${encodeURIComponent(searchKey)}` : ""),
    }).then((response) => {
      if (response.status) {
        if (response.data.audienceData.length > 0) {
          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCounts,
            lastPage: response.data.campaignData?.length < 10,
          }));

          setAudiences(getAllAudiences(response));
        } else {
          setAudiences([]);
        }
      }
      setLoading(false);
    });
  }, [axios, activeBrand.ID, loader, page.page, searchKey]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <SubNavbar
        pageName={"Audiences"}
        buttons={[
          <CreateButton
            variant="contained"
            onClick={() => navigate(pages.createAudience.route)}
          >
            Create Audience
          </CreateButton>,
        ]}
      />

      <List
        audiences={audiences}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        component=""
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
